export interface ValidateModel {
  mobileNumber: string;
  register: boolean;
  otp: string;
}
